<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('banco-de-livros')" class="main pb-4" id="about-main">
      <b-container fluid="lg">
        <b-card no-body class="shadow-sm card_sistemacpv p-4">
          <b-row>
            <b-col cols="12" class="mt-1 mb-1" v-for="(material, index) in lists" :key="index">
              <b-link :href="material.LinkFree" >
                <b-card no-body class="p-3 card_sistemacpv border-light">
                  <div class="d-flex align-items-center">
                    <i class="fa-light fa-book fa-xl mr-2"></i>
                    <span>{{ material.title }}</span>
                  </div>
                </b-card>
              </b-link>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

  <script>  
export default {
  data() {
    return {
      pageTitle: 'Banco de Livros',
      pageSubtitle: 'Ensino Fundamental I - 4º Ano',
      NamePermission: '',
      IndexPermission: '',
      lists: [
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-4-ano/carlos-chagas_%28biografia%29.pdf',
          videoId: '',
          src: '',
          segment: '1',
          bundle: 'books',
          title: 'Carlos Chagas',
          discipline: 'Carlos Chagas',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: '4º ano',
        },
        {
          linkReaOnly: '',
          LinkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-4-ano/curupira.pdf',
          videoId: '',
          src: '',
          segment: '1',
          bundle: 'books',
          title: 'Curupira',
          discipline: 'Curupira',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: '4º ano',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-4-ano/os-musicos-de-bremen.pdf',
          videoId: '',
          src: '',
          segment: '1',
          bundle: 'books',
          title: 'Os Músicos de Bremen',
          discipline: 'Os Músicos de Bremen',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: '4º ano',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-4-ano/padre%20landell_%28biografia%29.pdf',
          videoId: '',
          src: '',
          segment: '1',
          bundle: 'books',
          title: 'Padre Landell',
          discipline: 'Padre Landell',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: '4º ano',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-4-ano/palavras-ao-mar_hist%C3%B3ria_da_l%C3%ADngua_portuguesa.pdf',
          videoId: '',
          src: '',
          segment: '1',
          bundle: 'books',
          title: 'Palavras ao Mar',
          discipline: 'Palavras ao Mar',
          description: 'Ensino Fundamental I',
          toolTip: ' ',
          anoSerie: '4º ano',
        },
      ],
    };
  },

  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    formatParam(param) {
      return param.replace(/\s+/g, '-');
    },
  },
};
</script>

 <style scoped> 
.main {
  margin-top: 30px;
}

.card_sistemacpv {
    border-radius: 8px;
    color: #3A1C53;
}
</style>